import styles from "./Pagination.module.css";

type PaginationProps = {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
};

const Pagination = ({
  totalPages,
  currentPage,
  onPageChange,
}: PaginationProps) => {
  const visiblePages = () => {
    const windowSize = 4;
    const start = Math.max(1, currentPage - Math.floor(windowSize / 2));
    const end = Math.min(totalPages, start + windowSize - 1);
    const adjustedStart = Math.max(1, end - windowSize + 1);

    const pages = [];
    for (let i = adjustedStart; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className={styles.paginationContainer}>
      <p className={styles.title}>Pagina</p>
      <ul className={styles.paginationList}>
        {visiblePages().map((page) => (
          <li key={page}>
            <button
              className={
                page === currentPage
                  ? styles.paginationActiveListItem
                  : styles.paginationListItem
              }
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Pagination;
